// i18n.js
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import messages from './ProductData'

function getCountry() { //获取country参数值
  var languageCode = navigator.language || navigator.userLanguage; 
  // console.log(languageCode)
  return languageCode.includes('th')//是否是泰国
}

Vue.use(VueI18n);
const i18n = new VueI18n({
  locale: getCountry() ? 'THA':'EN', // 非泰语是英语
  messages, // 设置语言信息
});
 
export default i18n;
// http://192.168.1.4:8888/Motul/index.html?modelCode=model5012X1L&serialNub=1111
